/* HALLOWEEN — JS propio (vanilla). Cada init comprueba si su elemento existe. */

document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCompare();
  initGallery();
  initVariantPicker();
  initCountdown();
  initDelivery();
  initMascot();
  initStickyCta();
});

/* Revelado al hacer scroll */
function initReveal() {
  var els = document.querySelectorAll('.hw-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('hw-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('hw-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  els.forEach(function (el, i) {
    if (!el.style.getPropertyValue('--hw-delay')) el.style.setProperty('--hw-delay', (i % 5) * 80);
    observer.observe(el);
  });
}

/* Comparador antes/después */
function initCompare() {
  document.querySelectorAll('.hw-compare').forEach(function (wrap) {
    var afterWrap = wrap.querySelector('.hw-compare__after-wrap');
    var handle = wrap.querySelector('.hw-compare__handle');
    if (!afterWrap || !handle) return;
    var dragging = false;

    function apply(pct) {
      wrap.style.setProperty('--hw-compare-pos', pct + '%');
      afterWrap.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.setAttribute('aria-valuenow', Math.round(pct));
    }
    function setPos(clientX) {
      var rect = wrap.getBoundingClientRect();
      apply(Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100)));
    }
    function down(x) { dragging = true; setPos(x); }
    function move(e) {
      if (!dragging) return;
      setPos(e.touches ? e.touches[0].clientX : e.clientX);
    }
    function up() { dragging = false; }

    wrap.addEventListener('mousedown', function (e) { down(e.clientX); });
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
    wrap.addEventListener('touchstart', function (e) { down(e.touches[0].clientX); }, { passive: true });
    window.addEventListener('touchmove', move, { passive: true });
    window.addEventListener('touchend', up);

    handle.setAttribute('tabindex', '0');
    handle.addEventListener('keydown', function (e) {
      var cur = parseFloat(wrap.style.getPropertyValue('--hw-compare-pos')) || 50;
      if (e.key === 'ArrowLeft') apply(Math.max(0, cur - 5));
      else if (e.key === 'ArrowRight') apply(Math.min(100, cur + 5));
    });

    /* Pequeña demostración al entrar en pantalla: invita a deslizar */
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var demoObs = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        demoObs.disconnect();
        var t0 = null;
        function frame(t) {
          if (dragging) return;
          if (t0 === null) t0 = t;
          var p = (t - t0) / 1600;
          if (p >= 1) { apply(50); return; }
          apply(50 + Math.sin(p * Math.PI * 2) * 22 * (1 - p));
          requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
      }, { threshold: 0.6 });
      demoObs.observe(wrap);
    }
  });
}

/* Galería de producto: imagen principal + miniaturas */
function initGallery() {
  document.querySelectorAll('[data-hw-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-hw-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-hw-gallery-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (!full) return;
        main.style.opacity = '0';
        window.setTimeout(function () { main.setAttribute('src', full); main.style.opacity = '1'; }, 140);
        thumbs.forEach(function (t) { t.classList.remove('hw-active'); });
        thumb.classList.add('hw-active');
      });
    });
  });
}

/* Selector de color: id de variante, imagen, nombre y stock */
function initVariantPicker() {
  document.querySelectorAll('[data-hw-variant-picker]').forEach(function (picker) {
    var form = picker.closest('form');
    var hiddenId = form ? form.querySelector('input[name="id"]') : null;
    var gallery = document.querySelector('[data-hw-gallery]');
    var main = gallery ? gallery.querySelector('[data-hw-gallery-main]') : null;
    var swatches = picker.querySelectorAll('[data-hw-swatch]');
    if (!swatches.length) return;
    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        swatches.forEach(function (s) { s.classList.remove('hw-active'); });
        swatch.classList.add('hw-active');
        var nameEl = document.querySelector('[data-hw-color-name]');
        if (nameEl) nameEl.textContent = swatch.getAttribute('data-name') || '';
        var variantId = swatch.getAttribute('data-variant-id');
        if (hiddenId && variantId) hiddenId.value = variantId;
        var image = swatch.getAttribute('data-image');
        if (main && image) {
          main.style.opacity = '0';
          window.setTimeout(function () { main.setAttribute('src', image); main.style.opacity = '1'; }, 140);
        }
        var priceEl = document.querySelector('[data-hw-price]');
        if (priceEl && swatch.getAttribute('data-price')) priceEl.textContent = swatch.getAttribute('data-price');
        var cmpEl = document.querySelector('[data-hw-compare]');
        if (cmpEl) {
          var cmp = swatch.getAttribute('data-compare');
          cmpEl.textContent = cmp || '';
          cmpEl.hidden = !cmp;
        }
        var stock = parseInt(swatch.getAttribute('data-stock'), 10);
        var stockEl = document.querySelector('[data-hw-stock]');
        if (stockEl) {
          var limit = parseInt(stockEl.getAttribute('data-limit'), 10) || 0;
          if (!isNaN(stock) && stock > 0 && stock <= limit) {
            stockEl.hidden = false;
            var n = stockEl.querySelector('[data-hw-stock-n]');
            if (n) n.textContent = stock;
          } else {
            stockEl.hidden = true;
          }
        }
      });
    });
  });
}

/* Cuenta atrás hasta Halloween (31 de octubre, hora local del visitante) */
function initCountdown() {
  var wraps = document.querySelectorAll('[data-hw-countdown]');
  if (!wraps.length) return;
  var now = new Date();
  var target = new Date(now.getFullYear(), 9, 31, 0, 0, 0);
  if (now >= target) target = new Date(now.getFullYear() + 1, 9, 31, 0, 0, 0);

  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function tick() {
    var diff = target - new Date();
    if (diff < 0) diff = 0;
    var d = Math.floor(diff / 86400000);
    var h = Math.floor((diff % 86400000) / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    wraps.forEach(function (w) {
      var set = function (k, v) { var e = w.querySelector('[data-' + k + ']'); if (e) e.textContent = v; };
      set('hw-d', d); set('hw-h', pad(h)); set('hw-m', pad(m)); set('hw-s', pad(s));
      /* Fuera de temporada (más de 60 días) se oculta para no resultar raro */
      w.hidden = d > 60;
    });
  }
  tick();
  window.setInterval(tick, 1000);
  window.hwDaysToHalloween = Math.floor((target - now) / 86400000);
}

/* Fecha estimada de entrega: hoy + 4 y hoy + 5 días */
function initDelivery() {
  var els = document.querySelectorAll('[data-hw-delivery]');
  if (!els.length) return;
  var fmt;
  try {
    fmt = new Intl.DateTimeFormat('es-ES', { weekday: 'short', day: 'numeric', month: 'short' });
  } catch (e) { return; }
  function skipSunday(d) { if (d.getDay() === 0) d.setDate(d.getDate() + 1); return d; }
  var a = skipSunday(new Date(Date.now() + 4 * 86400000));
  var b = skipSunday(new Date(Date.now() + 5 * 86400000));
  if (b <= a) { b = skipSunday(new Date(a.getTime() + 86400000)); }
  var text = fmt.format(a).replace('.', '') + ' y ' + fmt.format(b).replace('.', '');
  els.forEach(function (el) { el.textContent = text; });
}

/* Mascota fantasma: ojos que siguen al cursor y frases al hacer clic */
function initMascot() {
  var m = document.querySelector('[data-hw-mascot]');
  if (!m) return;
  var pupils = m.querySelectorAll('[data-hw-pupil]');
  var bubble = m.querySelector('[data-hw-bubble]');
  var btn = m.querySelector('[data-hw-mascot-btn]');
  var lines = [
    '¡Buuu! Soy el fantasma de la casa.',
    'Este gesto es cariño. A mi manera.',
    'Envío GRATIS a toda España. Sí, también a Canarias y Baleares.',
    'Llega en 4-5 días. Antes de que se te acaben las excusas.',
    'Dicen que doy mala suerte… a los aburridos.',
    'Yo ya estoy en tu carrito. Falta que lo sepas.',
    'Mi lema: decorar con actitud.'
  ];
  var i = Math.floor(Math.random() * lines.length);
  var hideTimer;

  function look(x, y) {
    var r = m.getBoundingClientRect();
    var cx = r.left + r.width / 2, cy = r.top + r.height * 0.38;
    var dx = x - cx, dy = y - cy;
    var d = Math.sqrt(dx * dx + dy * dy) || 1;
    var k = Math.min(1, d / 160) * 4.2;
    var px = (dx / d) * k, py = (dy / d) * k;
    pupils.forEach(function (p) { p.setAttribute('transform', 'translate(' + px.toFixed(2) + ' ' + py.toFixed(2) + ')'); });
  }
  window.addEventListener('mousemove', function (e) { look(e.clientX, e.clientY); }, { passive: true });
  window.addEventListener('touchmove', function (e) { if (e.touches[0]) look(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });

  function say(text) {
    if (!bubble) return;
    bubble.textContent = text;
    bubble.classList.add('hw-show');
    window.clearTimeout(hideTimer);
    hideTimer = window.setTimeout(function () { bubble.classList.remove('hw-show'); }, 4200);
  }
  if (btn) {
    btn.addEventListener('click', function () {
      m.classList.remove('hw-boo');
      void m.offsetWidth;
      m.classList.add('hw-boo');
      var line = lines[i % lines.length];
      i++;
      if (window.hwDaysToHalloween !== undefined && window.hwDaysToHalloween <= 40 && i % 4 === 0) {
        line = 'Faltan ' + window.hwDaysToHalloween + ' días para Halloween. ¿Ya me has adoptado?';
      }
      say(line);
    });
  }
  /* Saluda una vez, sin ser pesado */
  var greeted = false;
  try { greeted = sessionStorage.getItem('hwGreeted') === '1'; } catch (e) {}
  if (!greeted) {
    window.setTimeout(function () {
      say('¡Buu! Si necesitas algo, estoy por aquí.');
      try { sessionStorage.setItem('hwGreeted', '1'); } catch (e) {}
    }, 4500);
  }
}

/* Barra de compra fija en móvil (aparece al pasar el botón principal) */
function initStickyCta() {
  var bar = document.querySelector('[data-hw-sticky]');
  var target = document.querySelector('[data-hw-sticky-target]');
  if (!bar || !target || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(function (entries) {
    var e = entries[0];
    bar.classList.toggle('hw-show', !e.isIntersecting && e.boundingClientRect.top < 0);
  }).observe(target);
}
